import gql from 'graphql-tag'

const createOrUpdateWorkPreferenceMutation = gql`
  mutation createOrUpdateWorkPreferenceInfo($expertId: String!, $input: ExpertWorkPreferenceInput!) {
    createOrUpdateWorkPreferenceInfo(expertId: $expertId, input: $input) {
      workPreferenceId
    }
  }
`

export default createOrUpdateWorkPreferenceMutation
